var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"assignment-results"},_vm._l((_vm.parts),function(part){return _c('design-2021-group-results-part-component',{key:part.id,attrs:{"part-in":part}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }